import css from "styled-jsx/css";
import { UI_BORDER_LIGHT_COLOR_NAME } from "styles/color-consts";
import Colors from "styles/colors";

export const componentStyles = css`
  .product-description {
    display: flex;
    padding: 0 16px 16px;
    flex-direction: column;
    gap: 24px;

    :global(.signup-button) {
      height: 40px;
    }

    .divider {
      height: 1px;
      width: 100%;
      padding: 0 20px;
      background-color: ${Colors[UI_BORDER_LIGHT_COLOR_NAME]};
    }

    .features {
      display: flex;
      width: max-content;
      flex-direction: column;
      gap: 12px;
      color: ${ Colors.asphalt };

      .features-title {
        font-size: 0.875rem;
        width: fit-content;
      }

      .features-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        row-gap: 8px;
        column-gap: 24px;

        .feature {
          font-size: 0.75rem;
          gap: 8px;
          width: fit-content;
          display: flex;
          align-items: center;
        }
      }
    }
  }
`;
